import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import PageDetail from './pages/PageDetail';
import Minilaesser from './pages/Minilaesser';
import Liftudlejning from './pages/Liftudlejning';
import Minikran from './pages/Minikran';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

// Scroll Restoration komponent til sideskift
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Øjeblikkelig scroll uden animation for bedste UX
    });
  }, [pathname]);

  return null;
}

function AppContent() {
  return (
    <div className="flex min-h-screen flex-col bg-brand-black text-white antialiased selection:bg-brand-yellow selection:text-white">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Header */}
      <Header />
      <Navigation />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/minilaesser" element={<Minilaesser />} />
          <Route path="/liftudlejning" element={<Liftudlejning />} />
          <Route path="/minikran" element={<Minikran />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/403" element={<Forbidden />} />
          
          {/* Dynamisk catch-all rute til alle undersider og kategorier */}
          <Route path="/:slug" element={<PageDetail />} />
          
          {/* Ugyldige ruter omdirigeres til 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AppContent />
    </HelmetProvider>
  );
}
